export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/vision.77304e06-204b99.png";